import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { Role } from '@shared/models';
import { Pagination } from '@shared/pagination';
import { RoleService } from '@shared/services';

import { rolesGet, rolesGetSuccess, rolesLoad, rolesLoadSuccess } from './roles.actions';

@Injectable()
export class RolesEffects {
  loadAll$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(rolesLoad),
      map((action) => action.payload),
      switchMap((payload) =>
        this.roleService
          .get(payload)
          .pipe(map((rolesPage: Pagination<Role>) => rolesLoadSuccess({ payload: rolesPage }))),
      ),
    ),
  );

  load$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(rolesGet),
      map((action) => action.payload),
      switchMap((id) =>
        this.roleService.get({ id }).pipe(map((role: Role) => rolesGetSuccess({ payload: role }))),
      ),
    ),
  );

  constructor(private actions$: Actions, private roleService: RoleService) {}
}
